import { AlertTriangle, X } from 'lucide-react';
import { useNavigate, useSearch } from '@tanstack/react-router';

type LooseNavigate = (opts: {
  to?: string;
  search?: unknown;
  replace?: boolean;
}) => unknown;

const STRIP_NOTICE = (prev: Record<string, unknown>) => ({
  ...prev,
  notice: undefined,
});

export function NoAccessBanner() {
  const search = useSearch({ strict: false }) as { notice?: string };
  const navigate = useNavigate() as unknown as LooseNavigate;

  if (search.notice !== 'no-access-to-campaign') return null;

  const handleDismiss = () => {
    navigate({ search: STRIP_NOTICE, replace: true });
  };

  return (
    <div className="bg-yellow-50 border-b border-yellow-200 px-4 py-2 flex items-center justify-between">
      <div className="flex items-center gap-2 text-sm text-yellow-800">
        <AlertTriangle className="h-4 w-4" />
        <span>You don't have access to that campaign. Pick one below.</span>
      </div>
      <button
        type="button"
        onClick={handleDismiss}
        aria-label="Dismiss"
        className="text-yellow-800 hover:text-yellow-900"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
